'use strict';

function lastViewKey(userId, projectId) {
  return `pulse-last-view:${userId}:${projectId}`;
}

function readLastView(storage, userId, projectId) {
  try {
    const raw = storage.getItem(lastViewKey(userId, projectId));
    if (!raw) return null;
    const ms = Date.parse(raw);
    return Number.isFinite(ms) ? new Date(ms).toISOString() : null;
  } catch {
    return null;
  }
}

function writeLastView(storage, userId, projectId, iso) {
  try {
    storage.setItem(lastViewKey(userId, projectId), iso || new Date().toISOString());
  } catch { /* ignore quota */ }
}

function defaultSince(storage, userId, projectId, now = new Date()) {
  const last = readLastView(storage, userId, projectId);
  if (last) return last;
  const d = new Date(now.getTime() - 14 * 24 * 60 * 60 * 1000);
  return d.toISOString();
}

/** Snapshot the What-changed window, then record this visit so Reset cannot collapse to now. */
function openPulseWindow(storage, userId, projectId, now = new Date()) {
  const since = defaultSince(storage, userId, projectId, now);
  writeLastView(storage, userId, projectId, now.toISOString());
  return since;
}

export { lastViewKey, readLastView, writeLastView, defaultSince, openPulseWindow };
